import { createContext } from 'preact';

const PrerenderDataContext = createContext(null);

export { PrerenderDataContext };
